import { render, staticRenderFns } from "./GlassesFrame.vue?vue&type=template&id=2d8bed3e&scoped=true&"
import script from "./GlassesFrame.vue?vue&type=script&lang=js&"
export * from "./GlassesFrame.vue?vue&type=script&lang=js&"
import style0 from "./GlassesFrame.vue?vue&type=style&index=0&id=2d8bed3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8bed3e",
  null
  
)

export default component.exports